import { render, staticRenderFns } from "./feedbackDetails.vue?vue&type=template&id=6700a148&scoped=true&"
import script from "./feedbackDetails.vue?vue&type=script&lang=js&"
export * from "./feedbackDetails.vue?vue&type=script&lang=js&"
import style0 from "./feedbackDetails.vue?vue&type=style&index=0&id=6700a148&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6700a148",
  null
  
)

export default component.exports